import All from 'assets/OfferTypeIcons/all.svg';
import AllGray from 'assets/OfferTypeIcons/all_gray.svg';
import FoodAndDrink from 'assets/OfferTypeIcons/dining.svg';
import FoodAndDrinkGray from 'assets/OfferTypeIcons/dining_gray.svg';
import Entertainment from 'assets/OfferTypeIcons/entertainment.svg';
import EntertainmentGray from 'assets/OfferTypeIcons/entertainment_gray.svg';
import EventsAndPerks from 'assets/OfferTypeIcons/events.svg';
import EventsAndPerksGray from 'assets/OfferTypeIcons/events_gray.svg';
import Gaming from 'assets/OfferTypeIcons/gaming.svg';
import GamingGray from 'assets/OfferTypeIcons/gaming_gray.svg';
import GiftsAndDiscounts from 'assets/OfferTypeIcons/gifts_discounts.svg';
import GiftsAndDiscountsGray from 'assets/OfferTypeIcons/gifts_discounts_gray.svg';
import Golf from 'assets/OfferTypeIcons/golf.svg';
import GolfGray from 'assets/OfferTypeIcons/golf_gray.svg';
import Hotel from 'assets/OfferTypeIcons/hotel.svg';
import HotelGray from 'assets/OfferTypeIcons/hotel_gray.svg';
import LoyaltyCredits from 'assets/OfferTypeIcons/loyalty_credits.svg';
import LoyaltyCreditsGray from 'assets/OfferTypeIcons/loyalty_credits_gray.svg';
import Other from 'assets/OfferTypeIcons/other.svg';
import OtherGray from 'assets/OfferTypeIcons/other_gray.svg';
import Transportation from 'assets/OfferTypeIcons/transportation.svg';
import TransportationGray from 'assets/OfferTypeIcons/transportation_gray.svg';
import TravelPackages from 'assets/OfferTypeIcons/travel.svg';
import TravelPackagesGray from 'assets/OfferTypeIcons/travel_gray.svg';
import Wellness from 'assets/OfferTypeIcons/wellness.svg';
import WellnessGray from 'assets/OfferTypeIcons/wellness_gray.svg';

import {OfferType} from 'models/Offer';

interface Props {
  offerType: OfferType;
  isSelected: boolean | undefined;
}

export const getOfferTypeIcon = ({offerType, isSelected}: Props) => {
  switch (offerType) {
    case OfferType.Gaming:
      return isSelected ? Gaming : GamingGray;
    case OfferType.Hotel:
      return isSelected ? Hotel : HotelGray;
    case OfferType.LoyaltyCredits:
      return isSelected ? LoyaltyCredits : LoyaltyCreditsGray;
    case OfferType.FoodAndDrink:
      return isSelected ? FoodAndDrink : FoodAndDrinkGray;
    case OfferType.Wellness:
      return isSelected ? Wellness : WellnessGray;
    case OfferType.Entertainment:
      return isSelected ? Entertainment : EntertainmentGray;
    case OfferType.EventsAndPerks:
      return isSelected ? EventsAndPerks : EventsAndPerksGray;
    case OfferType.Golf:
      return isSelected ? Golf : GolfGray;
    case OfferType.TravelPackages:
      return isSelected ? TravelPackages : TravelPackagesGray;
    case OfferType.Transportation:
      return isSelected ? Transportation : TransportationGray;
    case OfferType.GiftsAndDiscounts:
      return isSelected ? GiftsAndDiscounts : GiftsAndDiscountsGray;
    case OfferType.Other:
      return isSelected ? Other : OtherGray;
    default:
      return isSelected ? All : AllGray;
  }
};
